// Default meta for layout
module.exports = {
  title: " Magento 2 | Web Development | Taiwan | Lucid Modules",
  keywords: "magento 2, web development, pwa, taiwan, experts",
  description:
    "Lucid Modules is a group of software development and ecommerce enthusiasts. Magento 2, WordPress, PWA, Web Design, Web Development. Taipei, Taiwan.",
  og: {
    locale: "en_US",
  },
}
